export const outcomesWithoutCid = [
  {
    id: 'f92ee290-c5b9-44f7-8aa1-2c439fcaa3dd',
    name: 'No appointment',
  },
  {
    id: '7ecf5e90-5683-42fa-9d76-f8b93c0b7f90',
    name: 'Patient did not attend the appointment',
  },
  {
    id: '2a2d0c4f-8b16-4c27-9309-d9b54739bb85',
    name: 'Test consultation',
  },
  {
    id: '90c6c79f-12f3-4b8f-9822-3a2c1c8b9435',
    name: 'Unstable connection/Connection drop',
  },
  {
    id: '23bde71d-7c21-4a30-88a9-704b5c203b47',
    name: 'No audio or video',
  },
  {
    id: 'e8b494a5-4289-4f8b-b06b-78ed6b922516',
    name: 'Seeking specialist care',
  },
];
